import { APPLICATIONS, ScholarshipServicePath } from "utils/constants";
import permissions from "app/permissions";
import BeenhereIcon from "@mui/icons-material/Beenhere";
import ListApprovedScholarships from "./List";

export const resources = {
  isMenu: true,
  icon: <BeenhereIcon />,
  name: ScholarshipServicePath + "approved/" + APPLICATIONS,
  title: "Одобрени кандидатури",
  list: <ListApprovedScholarships />,
  //   show: <ShowScholarshipApplications />,
  permission: permissions.canPreviewScholarshipApplications,
};
